var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3867 21.72C14.9067 22.24 15.7467 22.24 16.2667 21.72L21.0533 16.9333C21.5733 16.4133 21.5733 15.5733 21.0533 15.0533L16.2667 10.2667C15.7467 9.74667 14.9067 9.74667 14.3867 10.2667C13.8667 10.7867 13.8667 11.6267 14.3867 12.1467L16.8933 14.6667H5.33333C4.6 14.6667 4 15.2667 4 16C4 16.7333 4.6 17.3333 5.33333 17.3333H16.8933L14.3867 19.84C13.8667 20.36 13.88 21.2133 14.3867 21.72ZM25.3333 4H6.66667C5.18667 4 4 5.2 4 6.66667V10.6667C4 11.4 4.6 12 5.33333 12C6.06667 12 6.66667 11.4 6.66667 10.6667V8C6.66667 7.26667 7.26667 6.66667 8 6.66667H24C24.7333 6.66667 25.3333 7.26667 25.3333 8V24C25.3333 24.7333 24.7333 25.3333 24 25.3333H8C7.26667 25.3333 6.66667 24.7333 6.66667 24V21.3333C6.66667 20.6 6.06667 20 5.33333 20C4.6 20 4 20.6 4 21.3333V25.3333C4 26.8 5.2 28 6.66667 28H25.3333C26.8 28 28 26.8 28 25.3333V6.66667C28 5.2 26.8 4 25.3333 4Z",
    fill: "#254A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.11ff060b082ee8b55ebd2c82202d6bd6.svg";
export { ForwardRef as ReactComponent };